import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Category } from '../models/category.model';
import { CategoryService } from '../services/category.service';
import { Validators } from '@angular/forms';

@Component({
    selector: 'ng-category-form',
    templateUrl: 'category-form.component.html'
})

export class CategoryFormComponent extends BaseFormComponent<Category> {

    constructor(protected injector: Injector, protected categoryServ: CategoryService) {
        super(injector, 'category', '/admin/settings/category', Category.fromJsonToObject, categoryServ);
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            name: this.formBuilder.control(null, [Validators.required]),
            id: this.formBuilder.control(null),
        })
    }

    protected initChildProprieties(): void { }
    protected initChildMethods(): void { }
}